<template>
	<div id="app">
		<router-view/>
		<Login />
		<Register />
	</div>
</template>

<script>
import Login from './components/Login.vue';
import Register from './components/Register.vue';
export default {
    components: {
        Login,
        Register,
    },
};
</script>


<style >
@import './assets/css/main.css';
</style>
<style lang="scss">
@mixin wrapper {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
html,
body {
    @include wrapper;
}
#app {
    @include wrapper;
    font-family:  ui-sans-serif, system-ui, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif;
    font-size: 0.8rem;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
</style>

<!-- <style>
img {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          animation: safeRun 5s linear infinite;
        }
        @keyframes safeRun{
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }</style> -->